import { Button, Col, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { setPeriodOptions } from "features/payment/slices/PaymentSlices";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

const CreateSpecialPeriodModal = ({
    isSpecialPeriodModalOpen = false,
    setIsSpecialPeriodModalOpen = () => { },
    employmentTypeDropdown = [],
    onCreateSpecialSubmit = () => { },
    updatePeriodOptions = () => { },
}) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const dispatch = useDispatch()
    const { periodOptions } = useSelector((state) => state.payment)

    const option = useMemo(() => {
        // return 
        console.log("periodOptions", periodOptions);

        return periodOptions?.map(o => {
            return {
                ...o,
                label: o.name,
                value: o.id
            }
        })

    }, [periodOptions])

    return (
        <Modal
            title={t("payroll.create_special_period")}
            closable={false}
            open={isSpecialPeriodModalOpen}
            footer={false}
            width={"40vw"}
        >
            <FormAntd
                form={form}
                onFinish={(values) => {
                    onCreateSpecialSubmit(values, form.resetFields);

                }}
            >
                <FormItem shouldUpdate={(prev, cur) => false}>
                    {({ getFieldValue, setFieldValue, resetFields }) => {
                        return (
                            <Space size={16} style={{ width: "100%" }} direction="vertical">
                                <Row gutter={16} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormSelect
                                            name="employmentType"
                                            label={t("salary.label.employment_type")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            options={employmentTypeDropdown}
                                            onChange={(e) => {
                                                updatePeriodOptions(getFieldValue("month")?.format?.("MM"), e)
                                            }}
                                        // mode="multiple"
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormDatePicker
                                            name="month"
                                            label={t("unit.month")}
                                            size="large"
                                            picker="month"
                                            dateFormat="MMMM"
                                            placeholder={t("common.pleaseSelect")}
                                            onChange={(e) => {
                                                console.log("onc", e.format("MM"), getFieldValue("employmentType"));
                                                updatePeriodOptions(e.format("MM"), getFieldValue("employmentType"))
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={16} style={{ marginLeft: "0px" }}>
                                    {/* <Col span={12}>
                                        <FormDatePicker
                                            name="year"
                                            label={t("unit.year")}
                                            size="large"
                                            picker="year"
                                            dateFormat="YYYY"
                                            placeholder={t("common.pleaseSelect")}
                                        />
                                    </Col> */}
                                    <Col span={12}>
                                        <FormSelect
                                            name="periodId"
                                            required
                                            label={t('report.payroll_period')}
                                            allowClear
                                            style={{
                                                width: '100%',
                                            }}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            options={option}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormDatePicker
                                            name="paymentDate"
                                            label={t("payment_period.label.paymentDate")}
                                            size="large"
                                        // type="range"
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={16} justify={"end"} style={{ gap: "12px" }}>
                                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => {
                                        resetFields();
                                        setIsSpecialPeriodModalOpen(false);
                                        dispatch(setPeriodOptions([]))
                                    }}>
                                        <span style={{ color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                                    </Button>
                                    <Button htmlType="submit" type="primary"
                                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                                    >
                                        {t("common.submit").toUpperCase()}
                                    </Button>
                                </Row>
                            </Space>
                        )
                    }}
                </FormItem>
            </FormAntd>
        </Modal >
    )
}

export default CreateSpecialPeriodModal;